import '../../style/index.less';
import './index.less';
// style dependencies
// deps-lint-skip: menu
import '../../button/style';
import '../../empty/style';
import '../../radio/style';
import '../../checkbox/style';
import '../../dropdown/style';
import '../../spin/style';
import '../../pagination/style';
import '../../tooltip/style';
